"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import DistributionDialog from "../../../../components/dialog/DistributionDialog.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import UiDialog from "@/components/dialog/UiDialog.vue";
const gridController = new GridController(
  // new APIDataSource("api://base.auth/api/v7/groups/shop_list")
  // base.auth.pro
  new APIDataSource("api://base.auth.pro/v1/shops")
);
let AccountBindShop = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = gridController;
    this.activeName = "first";
    this.selectLock = false;
    this.selectDatas = [];
    this.searchStr = "";
    this.distribution_group = ["DISTRIBUTED", "UNDISTRIBUTED"];
    this.user_list = [];
    this.new_type = false;
    this.change_distrib = _.debounce((distrib) => __async(this, null, function* () {
      if (distrib.length === 1) {
        if (this.searchStr !== null && this.searchStr !== "") {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: `distribution==${distrib[0]},name=like='${this.searchStr}'`
          };
        } else {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: `distribution==${distrib[0]}`
          };
        }
      }
      if (distrib.length > 1) {
        if (this.searchStr !== null && this.searchStr !== "") {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: `name=like='${this.searchStr}'`
          };
        } else {
          this.gridController.query.params = {
            type: "USER_BIND"
          };
        }
      }
      yield this.gridController.search();
    }), 500);
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        if (this.distribution_group.length == 1) {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: `name=like='${searchStr}',distribution==${this.distribution_group[0]}`
          };
        } else {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: `name=like='${searchStr}'`
          };
        }
      }
      if (searchStr === null || searchStr === "") {
        if (this.distribution_group.length == 1) {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: `distribution==${this.distribution_group[0]}`
          };
        } else {
          this.gridController.query.params = {
            type: "USER_BIND",
            search: ""
          };
        }
      }
      this.gridController.query.current = 1;
      this.gridController.search();
    }, 500);
  }
  created() {
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.size = true;
    this.gridController.pagePosition = "dialog";
  }
  open(datas) {
    return __async(this, null, function* () {
      this.user_list = datas;
      this.searchStr = "";
      this.selectDatas = [];
      this.selectLock = false;
      this.new_type = false;
      this.gridController.query.params = {
        search: "",
        type: "USER_BIND"
      };
      this._distribution_shop.open();
      this._distribution_shop.setBtn(false);
      this._distribution_shop.setOptSpan(16, 8);
      yield this.gridController.search();
      this.$nextTick(() => __async(this, null, function* () {
        if (datas.length === 1) {
          const result = yield API.get(
            `api://base.auth.pro/v1/user/${datas[0].guid}/auth-shops`
          );
          for (let item of result.data.datas) {
            this._distribution_shop.add({
              id: item.id,
              label: item.name
            });
          }
          this.checkItem();
        }
      }));
    });
  }
  open_new(arr) {
    return __async(this, null, function* () {
      this.user_list = [];
      this.searchStr = "";
      this.selectDatas = [];
      this.selectLock = false;
      this.new_type = true;
      this.gridController.query.params = {
        search: "",
        type: "USER_BIND"
      };
      this._distribution_shop.open();
      this._distribution_shop.setBtn(false);
      this._distribution_shop.setOptSpan(16, 8);
      yield this.gridController.search();
      this.$nextTick(() => __async(this, null, function* () {
        if (arr && arr.length > 0) {
          for (let item of arr) {
            this._distribution_shop.add({
              id: item.id,
              label: item.label
            });
          }
          this.checkItem();
        }
      }));
    });
  }
  changed(data) {
    this.selectLock = true;
    if (this.new_type === false) {
      let rows = _.differenceWith(
        this.selectDatas,
        data,
        (selectData, data2) => selectData.id == data2.id
      );
      if (rows) {
        for (const row of rows) {
          this._multipleTable.toggleRowSelection(row, false);
        }
      }
    } else {
      let rows = _.differenceWith(
        this.selectDatas,
        data,
        (selectData, data2) => selectData.shopOldId == data2.id
      );
      if (rows) {
        for (const row of rows) {
          this._multipleTable.toggleRowSelection(row, false);
        }
      }
    }
    this.selectLock = false;
  }
  gridSort(data) {
    return __async(this, null, function* () {
      this.gridController.query.sort = "sort,desc";
    });
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      if (this.new_type === false) {
        this._distribution_shop.syncData(
          this.gridController.result.datas,
          items,
          "id",
          "name"
        );
      } else {
        this._distribution_shop.syncData(
          this.gridController.result.datas,
          items,
          "shopOldId",
          "name"
        );
      }
    }
  }
  checkItem() {
    this.selectLock = true;
    if (this._distribution_shop === void 0) {
      return;
    }
    let selectDatas = this._distribution_shop.getAll();
    if (this.new_type === false) {
      let rows = _.intersectionWith(
        this.gridController.result.datas,
        selectDatas,
        (selectData, data) => selectData.id == data.id
      );
      if (rows) {
        for (const row of rows) {
          this._multipleTable.toggleRowSelection(row, true);
        }
      }
    } else {
      let rows = _.intersectionWith(
        this.gridController.result.datas,
        selectDatas,
        (selectData, data) => selectData.shopOldId == data.id
      );
      if (rows) {
        for (const row of rows) {
          this._multipleTable.toggleRowSelection(row, true);
        }
      }
    }
    _.debounce(() => {
      this.selectLock = false;
    }, 600);
  }
  removeAllTooltip() {
    document.querySelectorAll(".el-tooltip__popper").forEach((el) => el.remove());
  }
  saved(data) {
    return __async(this, null, function* () {
      if (this.new_type === false) {
        let _ids = _.map(data, "id");
        let user_ids = _.map(this.user_list, "guid");
        try {
          if (user_ids.length === 1) {
            yield API.post(`api://base.auth.pro/v1/shops-users`, {
              model: "users.auth.shops",
              mode: "COVER",
              shopIds: _ids,
              userIds: user_ids
            });
          }
          if (user_ids.length > 1) {
            yield API.post(`api://base.auth.pro/v1/shops-users`, {
              model: "users.auth.shops",
              mode: "APPEND",
              shopIds: _ids,
              userIds: user_ids
            });
          }
          this.$message.success(
            this.$t("team_management.shop.dialog.success_message")
          );
          this._distribution_shop.close();
          this.$emit("success");
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      }
      if (this.new_type === true) {
        this.$emit("shops", { datas: data });
        this._distribution_shop.close();
      }
    });
  }
};
__decorateClass([
  Ref("distribution-shop")
], AccountBindShop.prototype, "_distribution_shop", 2);
__decorateClass([
  Ref("multipleTable")
], AccountBindShop.prototype, "_multipleTable", 2);
AccountBindShop = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiGrid,
      DistributionDialog
    }
  })
], AccountBindShop);
export {
  AccountBindShop as default
};
